import { defineMessages } from "react-intl";

const messages = defineMessages({
  permError: {
    id: "fileStorage.components.permError.error",
    defaultMessage: "You do not have permission to perform this action.",
  },
  permErrorMessage: {
    id: "fileStorage.components.permError.errorMessage",
    defaultMessage:
      "Please contact the Apex Business Automation Team if you should have access.",
  },
});

export default messages;
